import Button from '@material-ui/core/Button';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  root: {
    borderRadius: 20,
    position: 'relative',
    width: '100%',
    boxShadow: 'none',
  },
  label: {
    fontSize: 16,
    textTransform: 'capitalize',
  },
};

const SubmitComponent = (props) => (
  <Button color="primary" type="submit" variant="contained" {...props} />
);

export const SubmitButton = withStyles(styles)(SubmitComponent);
